/**
 * Master / brand-shell header label = authenticated (or impersonated) USER only.
 * Never Brand name. Never Master Account businessName.
 */
import { resolveImpersonationDisplayIdentity } from "../supportMode/impersonationIdentity";
import { resolveAuthenticatedDisplayIdentity } from "../auth/profileIdentity";

export function headerUserLabelForTest(userInfo, impersonationSession) {
  if (impersonationSession) {
    const identity = resolveImpersonationDisplayIdentity(
      impersonationSession,
      userInfo,
    );
    if (identity.fullName && identity.fullName !== "Account") {
      return identity.fullName;
    }
    if (identity.email) return identity.email;
    return "Account";
  }
  const identity = resolveAuthenticatedDisplayIdentity(userInfo);
  return identity.headerLabel || "Account";
}

/**
 * Canonical resolver for MasterLayout / TenantShell top-right chrome.
 * Brand / tenant names must never be passed in — only user + optional SM session.
 */
export function resolveMasterShellHeaderLabel({
  userInfo,
  impersonationSession = null,
  // Explicitly ignored — callers must not wire Brand into the header.
  currentBrand: _currentBrand,
  businessName: _businessName,
} = {}) {
  return headerUserLabelForTest(userInfo, impersonationSession || null);
}
